import { useCallback, useState } from 'react';
import { useGetVotesQuery } from '@bo-services/pollsApi';

export const useMemberVotes = (memberUuid: string) => {
  const [currentPage, setCurrentPage] = useState<number>(1);

  const { isError, data, isLoading } = useGetVotesQuery({
    uuid: memberUuid,
    page: currentPage
  });

  const handleCurrentPageChange = useCallback(() => {
    setCurrentPage((prevPage) => prevPage + 1);
  }, [setCurrentPage]);

  return {
    currentPage,
    onCurrentPageChange: handleCurrentPageChange,
    isError,
    isLoading,
    memberVotes: data?.votes || [],
    totalPages: data?.totalPages || 1
  };
};
